import { render, staticRenderFns } from "./serviceBusinessList.vue?vue&type=template&id=65a5a91c&scoped=true"
import script from "./serviceBusinessList.vue?vue&type=script&lang=js"
export * from "./serviceBusinessList.vue?vue&type=script&lang=js"
import style0 from "./serviceBusinessList.vue?vue&type=style&index=0&id=65a5a91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a5a91c",
  null
  
)

export default component.exports